import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';
import { isNativeApp, startGoogleLoginInApp } from '../lib/native';
import { ToastContainer } from '../components/Toast';
import { useToast } from '../hooks/useToast';
import '../styles/AuthPage.css';
import { edadDesde, MENSAJE_MENOR, MENSAJE_REVISION } from '../lib/edad';
import { LOGO, LOGO_SRCSET } from '../lib/imagenes';

function TermsModal({ onAccept, onReject }) {
  const contentRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const el = contentRef.current;
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) setScrolled(true);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px'
    }}>
      <div style={{
        background: '#1a0a0a', border: '1px solid rgba(192,57,43,0.3)', borderRadius: 16,
        width: '100%', maxWidth: 520, maxHeight: '90vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.6)'
      }}>
        {/* Header */}
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 28, textAlign: 'center', marginBottom: 8 }}>📜</div>
          <h2 style={{ color: 'white', fontFamily: 'Georgia, serif', margin: 0, textAlign: 'center', fontSize: 20 }}>
            Normas de Uso
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, textAlign: 'center', margin: '8px 0 0' }}>
            Leé y aceptá las normas para crear tu cuenta
          </p>
        </div>

        {/* Scrollable content */}
        <div
          ref={contentRef}
          onScroll={handleScroll}
          style={{ overflowY: 'auto', padding: '20px 24px', flex: 1, color: 'rgba(255,255,255,0.75)', fontSize: 14, lineHeight: 1.7 }}
        >
          <h4 style={{ color: '#e05c6e', marginTop: 0 }}>1. Respeto y buena conducta</h4>
          <p>Cupido con Mate es una plataforma para conexiones genuinas. Está prohibido cualquier comportamiento irrespetuoso, hostigamiento, insultos o acoso hacia otros usuarios.</p>

          <h4 style={{ color: '#e05c6e' }}>2. Perfil auténtico</h4>
          <p>Debés usar tu nombre real, fotos propias y datos verídicos. No se permiten perfiles falsos, suplantación de identidad ni uso de imágenes de terceros sin consentimiento.</p>

          <h4 style={{ color: '#e05c6e' }}>3. Contenido apropiado</h4>
          <p>Queda prohibido compartir contenido sexual explícito, violento, discriminatorio o ilegal. Las fotos de perfil deben ser apropiadas para todo público.</p>

          <h4 style={{ color: '#e05c6e' }}>4. Privacidad y datos</h4>
          <p>No podés solicitar ni difundir datos personales de otros usuarios (domicilio, teléfono, documento, etc.) sin su consentimiento explícito.</p>

          <h4 style={{ color: '#e05c6e' }}>5. Uso legítimo</h4>
          <p>Está prohibido el uso de la plataforma con fines comerciales, spam, estafas o cualquier actividad que viole las leyes argentinas vigentes.</p>

          <h4 style={{ color: '#e05c6e' }}>6. Menores de edad</h4>
          <p>El acceso está restringido a personas mayores de 18 años. Al crear una cuenta confirmás que sos mayor de edad.</p>

          <h4 style={{ color: '#e05c6e' }}>7. Consecuencias por incumplimiento</h4>
          <p>El incumplimiento de estas normas puede resultar en la suspensión temporal o eliminación permanente de tu cuenta, sin derecho a reembolso en caso de tener plan pago.</p>

          <h4 style={{ color: '#e05c6e' }}>8. Modificaciones</h4>
          <p>Cupido con Mate se reserva el derecho de actualizar estas normas. Los cambios serán comunicados por correo.</p>

          <div style={{ background: 'rgba(192,57,43,0.1)', border: '1px solid rgba(192,57,43,0.3)', borderRadius: 8, padding: '12px 16px', marginTop: 8 }}>
            <p style={{ margin: 0, fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>
              Al crear tu cuenta, aceptás estas normas y declarás ser mayor de 18 años y residir en San Juan, Argentina.
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div style={{ padding: '16px 24px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: 10 }}>
          <button
            onClick={onReject}
            style={{
              flex: 1, padding: '11px 0', borderRadius: 50, border: '1px solid rgba(255,255,255,0.15)',
              background: 'transparent', color: 'rgba(255,255,255,0.55)', cursor: 'pointer', fontSize: 14, fontWeight: 600
            }}
          >
            ✕ Rechazar
          </button>
          <button
            onClick={onAccept}
            style={{
              flex: 2, padding: '11px 0', borderRadius: 50, border: 'none',
              background: 'linear-gradient(135deg,#7b0d1e,#c0392b)', color: 'white',
              cursor: 'pointer', fontSize: 14, fontWeight: 700
            }}
          >
            ✅ Aceptar y crear cuenta
          </button>
        </div>
      </div>
    </div>
  );
}

const validateEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
const validatePass  = (p) => p.length >= 8 && /[A-Z]/.test(p) && /[0-9]/.test(p);

function VerifyEmailView() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  useEffect(() => {
    const token = searchParams.get('token'), id = searchParams.get('id');
    if (!token || !id) { setStatus('error'); return; }
    api.verifyEmail(id, token).then(() => setStatus('ok')).catch(() => setStatus('error'));
  }, []);
  return (
    <div className="auth-page" style={{ justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', padding: 48, maxWidth: 420, width: '100%' }}>
        {status === 'loading' && <><div style={{ fontSize: 48 }}>⏳</div><h2 style={{ color: 'white', fontFamily: 'var(--font-display)', marginTop: 16 }}>Verificando...</h2></>}
        {status === 'ok' && (
          <><img src={LOGO} srcSet={LOGO_SRCSET} sizes="100px" alt="Logo" style={{ width: 100, margin: '0 auto 20px' }} />
          <h2 style={{ color: 'white', fontFamily: 'var(--font-display)', marginBottom: 12 }}>¡Cuenta verificada!</h2>
          <p style={{ color: 'var(--texto-suave)', marginBottom: 24 }}>Ya podés ingresar.</p>
          <button className="btn btn-primary btn-lg" onClick={() => navigate('/auth')}>Ingresar 💘</button></>
        )}
        {status === 'error' && (
          <><div style={{ fontSize: 64 }}>❌</div>
          <h2 style={{ color: 'white', fontFamily: 'var(--font-display)', margin: '12px 0' }}>Enlace inválido</h2>
          <p style={{ color: 'var(--texto-suave)', marginBottom: 24 }}>El enlace expiró o ya fue usado.</p>
          <button className="btn btn-outline" onClick={() => navigate('/auth')}>Volver</button></>
        )}
      </div>
    </div>
  );
}

function ResetPasswordView() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toasts, success, error } = useToast();
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePass(form.password)) { error('Mínimo 8 caracteres, 1 mayúscula y 1 número.'); return; }
    if (form.password !== form.confirmPassword) { error('Las contraseñas no coinciden.'); return; }
    setLoading(true);
    try { await api.resetPassword({ userId: searchParams.get('id'), token: searchParams.get('token'), ...form }); setDone(true); }
    catch (e_) { error(e_.message); } finally { setLoading(false); }
  };
  if (done) return (
    <div className="auth-page" style={{ justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', padding: 48 }}>
        <div style={{ fontSize: 64 }}>🎉</div>
        <h2 style={{ color: 'white', fontFamily: 'var(--font-display)', margin: '12px 0' }}>¡Contraseña actualizada!</h2>
        <button className="btn btn-primary" onClick={() => navigate('/auth')}>Ingresar</button>
      </div>
    </div>
  );
  return (
    <div className="auth-page" style={{ justifyContent: 'center' }}>
      <ToastContainer toasts={toasts} />
      <div style={{ width: '100%', maxWidth: 420, padding: '0 16px' }}>
        <h2 style={{ color: 'white', fontFamily: 'var(--font-display)', marginBottom: 20 }}>🔑 Nueva contraseña</h2>
        <form onSubmit={handleSubmit} className="auth-form" noValidate>
          <div className="form-group"><label className="form-label">Nueva contraseña</label><input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} /></div>
          <div className="form-group"><label className="form-label">Confirmar</label><input className="form-input" type="password" value={form.confirmPassword} onChange={e => setForm(f => ({ ...f, confirmPassword: e.target.value }))} /></div>
          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>{loading ? '⏳ Guardando...' : 'Guardar contraseña'}</button>
        </form>
      </div>
    </div>
  );
}

function ForgotForm({ onBack, error, success }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) { error('Correo inválido.'); return; }
    setLoading(true);
    try { await api.forgotPassword(email); setSent(true); }
    catch (e_) { error(e_.message); } finally { setLoading(false); }
  };
  if (sent) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>📧</div>
      <h3 style={{ color: 'white', fontFamily: 'var(--font-display)', marginBottom: 8 }}>Revisá tu correo</h3>
      <p style={{ color: 'var(--texto-suave)', marginBottom: 20 }}>Si tu correo está registrado, recibirás el enlace en breve.</p>
      <button className="auth-toggle-btn" onClick={onBack}>Volver al login</button>
    </div>
  );
  return (
    <>
      <h3 style={{ color: 'white', fontFamily: 'var(--font-display)', marginBottom: 16 }}>Olvidé mi contraseña</h3>
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="form-group"><label className="form-label">Correo registrado</label><input className="form-input" type="email" placeholder="tu@email.com" value={email} onChange={e => setEmail(e.target.value)} /></div>
        <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>{loading ? '⏳...' : '📧 Enviar enlace'}</button>
      </form>
      <p className="auth-toggle"><button className="auth-toggle-btn" onClick={onBack}>Volver al login</button></p>
    </>
  );
}

export default function AuthPage() {
  const pathname = window.location.pathname;
  if (pathname === '/verificar-email') return <VerifyEmailView />;
  if (pathname === '/reset-password') return <ResetPasswordView />;

  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState(searchParams.get('mode') === 'signup' ? 'signup' : 'login');
  const [showForgot, setShowForgot] = useState(searchParams.get('mode') === 'olvide');
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '', fechaNacimiento: '' });
  const [errors, setErrors] = useState({});
  const aviso = { menor: `🔞 ${MENSAJE_MENOR}`, revision: `⏸️ ${MENSAJE_REVISION}` }[searchParams.get('error')];
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const { user, register, login } = useAuth();
  const navigate = useNavigate();
  const { toasts, success, error } = useToast();

  useEffect(() => { if (user) navigate(user.profileComplete ? '/explorar' : '/perfil/setup', { replace: true }); }, [user, navigate]);

  const validate = () => {
    const e = {};
    if (!validateEmail(form.email)) e.email = 'Correo inválido.';
    if (!validatePass(form.password)) e.password = 'Mínimo 8 caracteres, 1 mayúscula y 1 número.';
    if (mode === 'signup') {
      if (!form.name.trim() || form.name.length < 2) e.name = 'Nombre mínimo 2 caracteres.';
      if (form.password !== form.confirmPassword) e.confirmPassword = 'Las contraseñas no coinciden.';
      const edad = edadDesde(form.fechaNacimiento);
      if (edad === null) e.fechaNacimiento = 'Ingresá tu fecha de nacimiento.';
      else if (edad < 18) e.fechaNacimiento = MENSAJE_MENOR;
    }
    return e;
  };

  const handleChange = (e) => { setForm(f => ({ ...f, [e.target.name]: e.target.value })); setErrors(er => ({ ...er, [e.target.name]: '' })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(); if (Object.keys(errs).length) { setErrors(errs); return; }
    if (mode === 'signup') { setShowTerms(true); return; }
    setLoading(true);
    try {
      const u = await login(form.email, form.password); success(`¡Bienvenido, ${u.name}!`); navigate(u.profileComplete ? '/explorar' : '/perfil/setup');
    } catch (e_) { error(e_.message?.includes('Verificá') ? 'Verificá tu correo antes de ingresar.' : e_.message); }
    finally { setLoading(false); }
  };

  const handleAcceptTerms = async () => {
    setShowTerms(false);
    setLoading(true);
    try { await register(form.name, form.email, form.password, form.confirmPassword, form.fechaNacimiento); setRegistered(true); }
    catch (e_) { error(e_.message); }
    finally { setLoading(false); }
  };

  if (registered) return (
    <div className="auth-page" style={{ justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', padding: 48, maxWidth: 420 }}>
        <img src={LOGO} srcSet={LOGO_SRCSET} sizes="80px" alt="Logo" style={{ width: 80, margin: '0 auto 16px' }} />
        <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
        <h2 style={{ color: 'white', fontFamily: 'var(--font-display)', marginBottom: 12 }}>¡Revisá tu correo!</h2>
        <p style={{ color: 'var(--texto-suave)', marginBottom: 24, lineHeight: 1.7 }}>Te enviamos un enlace de verificación a <strong style={{ color: 'var(--rojo-claro)' }}>{form.email}</strong>.</p>
        <button className="btn btn-outline btn-sm" onClick={() => api.resendVerification(form.email).then(() => success('Correo reenviado.')).catch(e_ => error(e_.message))}>Reenviar correo</button>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      {showTerms && <TermsModal onAccept={handleAcceptTerms} onReject={() => setShowTerms(false)} />}
      <ToastContainer toasts={toasts} />
      <div className="auth-left">
        <div className="auth-brand" onClick={() => navigate('/')}>
          <img src={LOGO} alt="Logo" srcSet={LOGO_SRCSET} sizes="44px" className="auth-brand-logo" />
          <span className="auth-brand-text">Cupido con Mate</span>
        </div>
        <div className="auth-left-content">
          <img src={LOGO} alt="Logo" srcSet={LOGO_SRCSET} sizes="(max-width: 768px) 80px, 120px" className="auth-left-logo" />
          <h2 className="auth-left-title">Tu próxima historia<br />empieza acá.</h2>
          <p className="auth-left-sub">Conectá con sanjuaninos reales. Perfiles verificados, gusto mutuo y seguridad total.</p>
          <div className="auth-badges">
            <div className="auth-badge-item">🔐 Seguridad real — bcrypt + JWT</div>
            <div className="auth-badge-item">📧 Correo verificado</div>
            <div className="auth-badge-item">💳 Freemium con MercadoPago</div>
            <div className="auth-badge-item">🤖 Moderación con IA</div>
          </div>
        </div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', position: 'relative', zIndex: 1 }}>
          © 2026 Cupido con Mate · San Juan&nbsp;·&nbsp;
          <button onClick={() => setShowTerms(true)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer', fontSize: 12, textDecoration: 'underline', padding: 0 }}>
            Normas de uso
          </button>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-card">
          {showForgot ? (
            <ForgotForm onBack={() => setShowForgot(false)} error={error} success={success} />
          ) : (
            <>
              {aviso && <div className="auth-menor">{aviso}</div>}
              <div className="auth-tabs">
                <button className={`auth-tab ${mode === 'login' ? 'active' : ''}`} onClick={() => { setMode('login'); setErrors({}); }}>Ingresar</button>
                <button className={`auth-tab ${mode === 'signup' ? 'active' : ''}`} onClick={() => { setMode('signup'); setErrors({}); }}>Crear cuenta</button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 18 }}>
                <button className="oauth-btn" onClick={() => isNativeApp() ? startGoogleLoginInApp() : (window.location.href = '/api/auth/google')}>
                  <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
                  Continuar con Google
                </button>
              </div>

              <div className="auth-divider">
                <div className="auth-divider-line" />
                <span className="auth-divider-text">o con correo</span>
                <div className="auth-divider-line" />
              </div>

              <form onSubmit={handleSubmit} className="auth-form" noValidate>
                {mode === 'signup' && (
                  <div className="form-group">
                    <label className="form-label">Nombre</label>
                    <input name="name" className="form-input" type="text" placeholder="¿Cómo te llamás?" value={form.name} onChange={handleChange} maxLength={60} />
                    {errors.name && <span className="form-error">{errors.name}</span>}
                  </div>
                )}
                {mode === 'signup' && (
                  <div className="form-group">
                    <label className="form-label">Fecha de nacimiento <span className="label-hint">(solo mayores de 18)</span></label>
                    <input name="fechaNacimiento" className="form-input" type="date" value={form.fechaNacimiento} onChange={handleChange} min="1915-01-01" max={new Date().toISOString().slice(0, 10)} />
                    {errors.fechaNacimiento && <span className="form-error">{errors.fechaNacimiento}</span>}
                  </div>
                )}
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input name="email" className="form-input" type="email" placeholder="tu@email.com" value={form.email} onChange={handleChange} />
                  {errors.email && <span className="form-error">{errors.email}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">Contraseña {mode === 'signup' && <span className="label-hint">(8+ chars, mayúscula, número)</span>}</label>
                  <input name="password" className="form-input" type="password" value={form.password} onChange={handleChange} autoComplete={mode === 'signup' ? 'new-password' : 'current-password'} />
                  {errors.password && <span className="form-error">{errors.password}</span>}
                </div>
                {mode === 'signup' && (
                  <div className="form-group">
                    <label className="form-label">Confirmar contraseña</label>
                    <input name="confirmPassword" className="form-input" type="password" value={form.confirmPassword} onChange={handleChange} autoComplete="new-password" />
                    {errors.confirmPassword && <span className="form-error">{errors.confirmPassword}</span>}
                  </div>
                )}
                <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                  {loading ? '⏳ Cargando...' : mode === 'signup' ? '🚀 Crear cuenta' : '💘 Ingresar'}
                </button>
              </form>

              {mode === 'login' && (
                <p style={{ textAlign: 'center', marginTop: 10 }}>
                  <button className="auth-toggle-btn" style={{ fontSize: 13 }} onClick={() => setShowForgot(true)}>¿Olvidaste tu contraseña?</button>
                </p>
              )}
              {mode === 'signup' && (
                <p style={{ textAlign: 'center', marginTop: 8 }}>
                  <button className="auth-toggle-btn" style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }} onClick={() => setShowTerms(true)}>
                    📜 Leer normas de uso
                  </button>
                </p>
              )}
              <p className="auth-toggle">
                {mode === 'login' ? '¿No tenés cuenta?' : '¿Ya tenés cuenta?'}{' '}
                <button className="auth-toggle-btn" onClick={() => { setMode(m => m === 'login' ? 'signup' : 'login'); setErrors({}); }}>
                  {mode === 'login' ? 'Registrate gratis' : 'Ingresá'}
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
